import React from 'react';

/**
 * PC 侧栏智能拖拽条（收缩态可点击展开）
 */
export default function DashboardSidebarDragHandle({
  collapsed,
  sidebarWidth,
  onExpand,
  onDragMouseDown
}) {
  return (
    <div
      onMouseDown={(e) => {
        if (collapsed) {
          onExpand?.(sidebarWidth);
        } else {
          onDragMouseDown?.(e);
        }
      }}
      style={{
        position: 'absolute',
        left: collapsed ? 0 : -5,
        top: 0,
        bottom: 0,
        width: collapsed ? 40 : 10,
        cursor: collapsed ? 'pointer' : 'col-resize',
        zIndex: 1000,
        background: collapsed ? 'linear-gradient(135deg, #1976d2, #1565c0)' : 'transparent',
        borderRadius: collapsed ? '0 8px 8px 0' : '0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        transition: 'all 0.3s ease',
        boxShadow: collapsed ? '2px 0 8px rgba(0,0,0,0.15)' : 'none'
      }}
      onMouseEnter={(e) => {
        if (collapsed) {
          e.currentTarget.style.background = 'linear-gradient(135deg, #1565c0, #0d47a1)';
          e.currentTarget.style.transform = 'translateX(2px)';
        }
      }}
      onMouseLeave={(e) => {
        if (collapsed) {
          e.currentTarget.style.background = 'linear-gradient(135deg, #1976d2, #1565c0)';
          e.currentTarget.style.transform = 'translateX(0)';
        }
      }}
      title={collapsed ? '点击展开队员信息' : '拖拽调整宽度'}
    >
      {collapsed && (
        <div style={{
          color: '#fff',
          fontSize: '12px',
          fontWeight: 'bold',
          writingMode: 'vertical-rl',
          textOrientation: 'mixed',
          whiteSpace: 'nowrap',
          letterSpacing: '2px'
        }}>
          点击展开队员信息
        </div>
      )}
    </div>
  );
}
